module.exports = __webpack_public_path__ + "static/media/icon-edit.55569845.svg";